module.exports = __webpack_public_path__ + "Refinitiv_st_reg_rgb.1c5233bb.png";